export enum SidebarSideEnum {
  Left = 'left',
  Right = 'right',
}
